import { forwardRef } from "react"

import { SelectX } from "web/components"

import { useSearch } from "web/hooks/data"
import { useCreateContactModal } from "web/hooks/modals"

import { isObjectWithProperty } from "web/services/helpers"

import ControlContainer from "./ControlContainer"
import ContactSuggestion from "web/components/SelectX/ContactSuggestion"

const ContactLookup = forwardRef((props, ref) => {
  const {
    name,
    value,
    kind,
    error,
    touched,
    multiple_values,
    onChange,
    onFocus,
    autoFocus,
    disabled = false,
    canShowAddXOption = true,
  } = props

  const search = useSearch("contact")
  const createContactModal = useCreateContactModal()

  async function decodeValue(rawValue) {
    return { value: rawValue.value, label: rawValue.label, kind }
  }

  async function handleSelectXChange(value) {
    if (value === null) {
      onChange(null)
    } else if (multiple_values) {
      const decodedValue = []

      for (const valueEl of value) {
        decodedValue.push(await decodeValue(valueEl))
      }

      onChange(decodedValue)
    } else {
      onChange(await decodeValue(value))
    }
  }

  async function handleQuickAdd(nameOfNew) {
    const contact = await createContactModal({ name: nameOfNew })

    if (isObjectWithProperty(contact, "id")) {
      const newValue = { value: contact.id, label: contact.full_name, kind }

      if (multiple_values) {
        onChange([...(value || []), newValue])
      } else {
        onChange(newValue)
      }
    }
  }

  return (
    <ControlContainer {...props} errorCondition={error && touched}>
      <SelectX
        ref={ref}
        name={name}
        value={value}
        onChange={handleSelectXChange}
        onFocus={onFocus}
        onAdd={canShowAddXOption ? handleQuickAdd : undefined}
        validValues={search}
        suggestionComponent={ContactSuggestion}
        options={{
          multipleValues: multiple_values || false,
          clearOnFocus: true,
          inputClassName: "form-control lookup",
          autoFocus,
          placeholder: "Search contacts...",
        }}
        disabled={disabled}
      />
    </ControlContainer>
  )
})

export default ContactLookup
